// extracted by mini-css-extract-plugin
export var blue = "br_fM";
export var button = "br_cf";
export var label = "br_cl";
export var orange = "br_fN";
export var white = "br_fP";